{
  "assignment": {
    "defaultTitle": "Submit your assignment",
    "maxFilesError_one": "Maximum of {{count}} file allowed",
    "maxFilesError_zero": "Maximum of {{count}} files allowed",
    "maxFilesError_other": "Maximum of {{count}} files allowed",
    "fileTooLarge": "{{name}} is too large. Maximum: {{size}}MB",
    "fileUploaded": "{{name}} uploaded successfully!",
    "fileUploadError": "Error uploading {{name}}",
    "addAtLeastOne": "Add at least one file",
    "waitAllUploads": "Wait for all files to finish uploading",
    "submitted": "Assignment submitted successfully!",
    "submitError": "Error submitting assignment",
    "dropHere": "Drop the files here...",
    "clickOrDrag": "Click or drag files here",
    "limits_one": "Up to {{count}} file, {{size}}MB each",
    "limits_zero": "Up to {{count}} files, {{size}}MB each",
    "limits_other": "Up to {{count}} files, {{size}}MB each",
    "acceptedTypes": "Accepted types: {{types}}",
    "filesCount": "Files ({{total}})",
    "status": {
      "completed": "Uploaded",
      "error": "Error",
      "uploading": "Uploading..."
    },
    "commentsLabel": "Comments (optional)",
    "commentsPlaceholder": "Add comments about your assignment...",
    "hint": {
      "empty": "Add files to continue",
      "waiting": "Wait for the upload to finish",
      "ready": "Ready to submit!",
      "errors": "Some files failed to upload"
    },
    "submitting": "Submitting...",
    "submit": "Submit assignment"
  },
  "download": {
    "defaultTitle": "Downloadable materials",
    "fileType": {
      "code": "Code",
      "file": "File"
    },
    "downloaded": "{{name}} downloaded successfully!",
    "error": "Error downloading file",
    "startingAll": "Starting download of all files...",
    "status": {
      "downloading": "Downloading...",
      "completed": "Downloaded!",
      "error": "Error",
      "idle": "Download"
    },
    "downloadAll": "Download all",
    "tips": {
      "title": "💡 Download tips",
      "programs": "• Some files may need specific programs to open",
      "organize": "• Keep your materials organized in a course folder",
      "zip": "• ZIP files contain multiple compressed files",
      "code": "• Code files can be opened in editors like VS Code"
    }
  },
  "pdf": {
    "loaded_one": "PDF loaded: {{count}} page",
    "loaded_zero": "PDF loaded: {{count}} pages",
    "loaded_other": "PDF loaded: {{count}} pages",
    "loadErrorDescription": "Error loading PDF. Check that the file is valid.",
    "loadError": "Error loading PDF",
    "downloadStarted": "Download started!",
    "downloadPdf": "Download PDF",
    "defaultTitle": "PDF document",
    "pages_one": "{{count}} page",
    "pages_zero": "{{count}} pages",
    "pages_other": "{{count}} pages",
    "download": "Download",
    "exitFullscreen": "Exit",
    "fullscreen": "Fullscreen",
    "pageOf": "{{page}} of {{total}}",
    "loading": "Loading PDF...",
    "navigationHint": "Use the ← → arrows to move between pages"
  },
  "richText": {
    "readingCompleted": "📖 Reading complete!",
    "readingCompletedDescription": "You have read all the content in this lesson.",
    "copied": "Content copied!",
    "defaultTitle": "Lesson content",
    "preparingPrint": "Preparing to print...",
    "readTime": {
      "lessThanOne": "Less than 1 min",
      "one": "1 min",
      "many": "{{minutes}} mins"
    },
    "percentRead": "{{percent}}% read",
    "hide": "Hide",
    "show": "Show",
    "copy": "Copy",
    "print": "Print",
    "progress": "Progress:",
    "endOfContent": "End of content"
  },
  "video": {
    "embedLoadError": "Could not load the video. Check the lesson link.",
    "downloadNotAllowed": "Download not allowed",
    "actionBlocked": "Action blocked for security",
    "lessonCompleted": "Lesson completed!",
    "lessonCompletedDescription": "Congratulations! You watched the whole lesson.",
    "invalidId": "Invalid video ID",
    "expectedFormat": "Expected format: 24 hexadecimal characters"
  },
  "media": {
    "invalidImageType": "Invalid file type. Use JPG, PNG, GIF or WebP.",
    "invalidVideoType": "Invalid file type. Use MP4, WebM, MOV or AVI."
  }
}
